export default __webpack_public_path__ + "static/media/indique.8f50771e.jpg";